import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import CONFIG from "../config";
import { encryptData } from "./crypto";

export const PrivateRoute = () => {
  const location = useLocation();
  const auth = useSelector((state) => state.auth.value);

  let storedAuth = null;

  try {
    storedAuth = JSON.parse(localStorage.getItem("auth"));
  } catch (e) {
    storedAuth = null;
  }

  const user = auth?.token ? auth : storedAuth;

  // =============================
  // NOT LOGGED IN
  // =============================
  if (!user?.token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const roleId = Number(user?.user?.role_id);

  // FIXED BOOLEAN (IMPORTANT)
  const hasPoints =
    user?.user?.has_user_points === true ||
    user?.user?.has_user_points === 1 ||
    user?.user?.has_user_points === "1" ||
    user?.user?.has_user_points === "true";

  const path = location.pathname;

  // =============================
  // HOME REDIRECT LOGIC
  // =============================
  if (path === "/") {
    if (roleId === 1) {
      return <Navigate to="/dashboard" replace />;
    }

    if (roleId === 2) {
      return hasPoints ? (
        <Navigate to="/dashboard-screen" replace />
      ) : (
        <Navigate to="/points-wallet" replace />
      );
    }
  }

  return <Outlet />;
};


export const PublicRoute = () => {
  let auth = useSelector((x) => x.auth.value);

  try {
    if (typeof auth === "string") {
      auth = JSON.parse(auth);
    }
  } catch (e) {
    auth = null;
  }

  if (auth?.token) {
    const roleId = Number(auth?.user?.role_id);

    const hasPoints =
      auth?.user?.has_user_points === true ||
      auth?.user?.has_user_points === 1 ||
      auth?.user?.has_user_points === "1" ||
      auth?.user?.has_user_points === "true";

    if (roleId === 2) {
      return hasPoints ? (
        <Navigate to="/dashboard-screen" replace />
      ) : (
        <Navigate to="/points-wallet" replace />
      );
    }

    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};



export const formatRequest = (data) => {
  if (CONFIG.IS_JSON) {
    return data;
  }

  return {
    q: encryptData(data),
  };
};

export const formatTime = (time24) => {
  if (!time24) return ""; // or return "N/A"

  const [hourStr, minute] = time24.split(":");
  let hour = parseInt(hourStr, 10);

  const ampm = hour >= 12 ? "PM" : "AM";
  hour = hour % 12 || 12;

  return `${hour}:${minute} ${ampm}`;
};

export function formatCurrencyINR(amount) {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  }).format(amount);
}

export function maskMobile(mobile = "") {
  const str = String(mobile);

  if (str.length < 10) return str;

  return `+91 ${str.slice(0, 2)}XXXXXX${str.slice(-2)}`;
}

export function getInitials(name = "") {
  return name
    .split(" ")
    .map((word) => word[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}
